import React from 'react'
import Dropzone from 'react-dropzone'
import FilePreviewComponent from './FilePreviewComponent'
import Button from '../DMGComponents/Button'
import Break from '../DMGComponents/Break'
import { uploadFiles } from '../fetchData';
import toast, { Toaster } from 'react-hot-toast';
import '../assets/css/FileUpload.css'
import UploadIcon from '../assets/img/Upload.png'
import closeIcon from '../assets/img/close.png'
import Checkbox from '../DMGComponents/Checkbox'

const baseStyle = {
    flex: 1,
    width: "100%",
    cursor: 'pointer',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#d8d8d8',
    borderStyle: 'dashed',
    backgroundColor: '#f1f1f1',
    color: '#8A8E91',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    marginBottom: 0
};

const activeStyle = {
    borderColor: '#068496'
};

let keyCounter = 0;

class FileUpload extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            filesToUpload: [],
            style: baseStyle,
            title: "Drag 'n' drop some files here, or click to select files",
            fileList: <div />,
            fileListSmall: <div />,
            selectedOption: null,
            intervalId: 0,
            fileprogress: null,
            uploadInProgress: false,
            selectedAreaStatus: this.props.areaStatus,
            exportRegulationsConfirmed: false,
        }
    }

    getWrappedString = (string) => {
        if (string <= 20) {
            return string;
        } else {
            string = string.slice(0, 17);
            string += "...";

            return string;
        }
    }

    cleanUpArray = (fileArray) => {
        let returnArray = [];
        let filesTooBig = [];
        let files0Bytes = [];
        fileArray.forEach((file) => {
            let isAlreadyInArray = false;
            let fileTooBig = false;
            let file0Bytes = false;
            if (file.size > this.props.maxFileSize * 1024 * 1024) {
                filesTooBig.push(file);
                fileTooBig = true;
            }
            else if (file.size === 0) {
                files0Bytes.push(file);
                file0Bytes = true;
            }
            else {
                this.state.filesToUpload.forEach((alreadyAddedFile) => {
                    isAlreadyInArray |= (file.name === alreadyAddedFile.name && file.size === alreadyAddedFile.size)
                })
            }
            if (!isAlreadyInArray && !fileTooBig && !file0Bytes) {
                returnArray.push(file);
            }
        })
        if (filesTooBig.length > 0) {
            let filesTooBigError = "Following files are too big: ";
            for (var i = 0; i < filesTooBig.length; i++) {
                let file = filesTooBig[i];
                filesTooBigError += file.name;
                if (i < filesTooBig.length - 1) {
                    filesTooBigError += ", ";
                }
            }
            toast.error(filesTooBigError);
        }
        if (files0Bytes.length > 0) {
            let files0BytesError = "Following files have 0 bytes: ";
            for (var i = 0; i < files0Bytes.length; i++) {
                let file = files0Bytes[i];
                files0BytesError += file.name;
                if (i < files0Bytes.length - 1) {
                    files0BytesError += ", ";
                }
            }
            toast.error(files0BytesError);
        }
        return returnArray;
    }

    selectFilesCallback = (fileArray) => {

        fileArray = this.cleanUpArray(fileArray);

        let newFilesToUpload = [];
        newFilesToUpload.push.apply(newFilesToUpload, this.state.filesToUpload);
        newFilesToUpload.push.apply(newFilesToUpload, fileArray);
        this.setState({
            style: baseStyle,
            title: "Drag 'n' drop some files here, or click to select files",
            filesToUpload: newFilesToUpload,
            fileListSmall: this.generateFileListSmall(newFilesToUpload),
            fileList: this.generateFileList(newFilesToUpload)
        });
    }

    dragEnterCallback = () => {
        this.setState({
            style: {
                ...baseStyle,
                ...activeStyle
            },
            title: "DROP THE FILES"
        })
    }

    dragLeaveCallback = () => {
        this.setState({
            style: {
                ...baseStyle,
            },
            title: "Drag 'n' drop some files here, or click to select files"
        })
    }

    convertToArray = (e) => {
        let returnArray = [];
        Array.prototype.forEach.call(e, (file) => {
            returnArray.push(file);
        })
        return returnArray;
    }

    removeFile(id) {
        let newFilesToUpload = this.state.filesToUpload;
        newFilesToUpload.splice(id, 1);

        this.setState({
            filesToUpload: newFilesToUpload,
            fileListSmall: this.generateFileListSmall(newFilesToUpload),
            fileList: this.generateFileList(newFilesToUpload)
        })

    }

    generateFileListSmall = (fileArray) => {
        return fileArray.map((file, i) => {
            let fileName = file.name;
            if (!fileName) {
                fileName = "Unknown Name";
            }
            keyCounter++;
            return (
                <div key={keyCounter}>
                    <span style={{ verticalAlign: "middle" }}>{this.getWrappedString(fileName)}</span>
                    <img
                        src={closeIcon}
                        alt="Close icon"
                        style={{ height: "1rem", marginLeft: "2px", verticalAlign: "middle", cursor: "pointer" }}
                        onClick={() => this.removeFile(i)}
                    />
                </div>
            )
        })
    }

    generateFileList = (fileArray) => {
        return fileArray.map((file, i) => {
            let fileName = file.name;
            if (!fileName) {
                fileName = "Unknown Name";
            }
            keyCounter++;
            return (
                <span key={keyCounter} style={{ width: "80px", display: "inline-block" }}>
                    <FilePreviewComponent name={fileName} onClick={() => { this.removeFile(i); }} />
                </span>
            )
        })
    }

    updateProgress = (p) => {
        this.setState({
            fileprogress: p.progressEvent.loaded / p.progressEvent.total
        })
    }

    uploadFiles = () => {
        if (this.state.filesToUpload.length > 0 && !this.state.uploadInProgress) {
            this.setState({
                uploadInProgress: true,
            })
           
            uploadFiles(this.props.areaId, this.state.filesToUpload, this.updateProgress).then(() => {
                this.uploadSuccess()
            }).catch((err) => {
                this.uploadFail(err)
            })
        }
    }

    uploadFail(err) {
        console.error("Error", err)
        this.setState({
            fileprogress: 1.0,
            filesToUpload: [],
            uploadInProgress: false,
        })
        this.props.refreshAreaContent()
        toast.error("Error uploading files.")
    }

    uploadSuccess() {
        this.setState({
            fileprogress: 1.0,
            filesToUpload: [],
            uploadInProgress: false,
        })
        this.props.refreshAreaContent()
        toast.success("File(s) uploaded.")
    }

    confirmExportRegulations = () => {
        this.setState({
            exportRegulationsConfirmed: !this.state.exportRegulationsConfirmed
        })
    }

    render() {
        return (
            <div style={{ ...this.props.style, textAlign: "left" }} className="fileExChildComponent">
                <Toaster />
                <Break>
                    <div style={{ display: "flex" }}>
                        <div style={{ marginRight: "44px" }}>
                            <img
                                src={UploadIcon}
                                alt="Upload"
                                style={{ height: "2rem", position: "absolute" }}
                            />
                        </div>
                        <div>
                            Upload
                        </div>
                    </div>
                </Break>
                {this.props.appWidth > 800 ?
                    <Dropzone
                        onDrop={this.selectFilesCallback}
                        onDragEnter={this.dragEnterCallback}
                        onDragLeave={this.dragLeaveCallback}
                        //noClick={this.state.filesToUpload.length > 0}
                    >
                        {({ getRootProps, getInputProps }) => {
                            return (
                                <section style={{ textAlign: "-webkit-center" }}>
                                    <div {...getRootProps({ style: this.state.style })}>
                                        <input {...getInputProps()} />
                                        {
                                            this.state.filesToUpload.length !== 0 ? (<div style={{ textAlign: "left" }}>{this.state.fileList}</div>) : <p>{this.state.title}</p>
                                        }

                                    </div>
                                </section>
                            )
                        }}
                    </Dropzone>
                    :
                    <div>
                        <input id="file" className="inputfile" style={{ margin: 5 }} type="file" onChange={e => this.selectFilesCallback(this.convertToArray(e.target.files))} multiple />
                        <label className="uploadButton" htmlFor="file">Select File</label>
                    </div>
                }

                <div style={{ marginTop: "8px" }}>
                    {!this.props.isAdHoc && this.state.selectedAreaStatus === 1 &&
                        <p>After uploading files users will be immediately notified about the changes.</p>
                    }
                    {!this.props.isAdHoc && this.state.selectedAreaStatus === 0 &&
                        <p>Notifications will be sent after the area is released.</p>
                    }
                    </div>

                <div style={{ display: "flex", justifyContent: "right", alignItems: "center", marginBottom: "4px" }}>
                    <Checkbox checked={this.state.exportRegulationsConfirmed} onClick={() => { this.confirmExportRegulations() }} style={{ marginRight: "20px" }}>I hereby confirm that the upload adheres to export law regulations</Checkbox>
                    <Button type="hover-bottom-left" onClick={this.uploadFiles} disabled={this.state.uploadInProgress || this.state.filesToUpload.length === 0 || !this.state.exportRegulationsConfirmed}>Upload</Button>
                </div>
                

                {this.props.appWidth <= 800 &&
                    (this.state.fileListSmall)
                }

                {this.state.uploadInProgress &&
                    <div className="file-progress">
                        <div className="file-progress-inner" style={{ width: (this.state.fileprogress && this.state.fileprogress * 100 + "%") }} />
                        <div>
                            {this.state.fileprogress && (this.state.fileprogress * 100).toLocaleString('fullwide', { maximumFractionDigits: 2 }) + "%"}
                        </div>
                    </div>
                }
                
            </div>
        );
    }

}
export default FileUpload;
